import React, { useState, useEffect } from 'react';

import S from './TextInput.module.scss';

const TextInput = ({ argument, onChange }) => {
  const [value, setValue] = useState('');

  // Initialiser la valeur depuis l'argument
  useEffect(() => {
    const initialValue = argument.valeurParDefaut || argument.value || '';
    setValue(initialValue);
  }, [argument.valeurParDefaut, argument.value]);

  // Mettre à jour la valeur
  const handleChange = (inputValue) => {
    setValue(inputValue);
    onChange('valeurParDefaut', inputValue);
  };

  return (
    <div className={S.textContainer}>
      <input
        type="text"
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        placeholder="Entrez du texte"
        className={S.textInput}
        required={argument.obligatoire}
      />
    </div>
  );
};

export default TextInput;
